import { Button, Modal, ModalBody, ModalFooter, Progress } from 'reactstrap'

const ProgressBarExportFile = (props) => {
  const { isDialogShow, firstRows = 0, totalRows = 0, onCancel, isFull } = props

  const progress = isFull
    ? 100
    : Math.min(100, Math.floor((firstRows / totalRows) * 100))

  return (
    <Modal
      isOpen={isDialogShow}
      className="modal-lg modal-dialog-centered"
      placement="top"
      target="center"
      size="md"
      data-testid="progress-bar-export-modal"
    >
      <ModalBody>
        {isDialogShow && (
          <div className="mt-2">
            <div className="text-center" data-testid="progress-bar-export-percent">
              {progress}%
            </div>
            <div>
              <Progress value={progress} animated data-testid="progress-bar-export-progress" />
            </div>
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="primary" onClick={() => onCancel()} data-testid="progress-bar-export-cancel">
          Batal
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ProgressBarExportFile
